<template>
  <div class="fichiersListe encart">
    <h2>Fichiers disponibles</h2>
    <div class="fichiersAcces">
      <!--<ListeFichiersAffaires />-->
      <RouterLink :to="'/fichiers-magasin/' + magasin"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
      </svg>Fichiers et photos du magasin</RouterLink>
      <RouterLink :to="'/fichiers-article/' + codeArticle"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
      </svg>Fichiers et photos de l'article</RouterLink>
    </div>
    
  </div>
</template>

<script>



export default {
  data() {
    return {
      codeArticle: '',
      selectedFile: '',
      magasin: '',
    }
  },
  created() {
    this.codeArticle = this.$route.params.codeArticle;
    this.magasin = this.$route.params.magasin;
  },
  

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;
  .link {
    display: flex;
    align-items: center;
    svg {
      margin-right: 5px;
      height: 12px;
      width: 12px;
      min-width: 12px!important;
      cursor: pointer;
      path {
        fill: #2b358d;
      }
    }
    a {
      color: #2b358d!important;
      svg {
        margin-left: 0px;
      }
    }
  }
  .fichiersListe {
    margin-bottom: 25px;
  }
  h2 {
    text-align: left;
  }

  .fichiersListe a {
    display: flex!important;;
    align-items: center!important;;
    color: #2b358d!important;
    text-decoration: none;
    font-weight: 500!important;;
    cursor: pointer;
    svg {
      margin-right: 5px;
      height: 18px!important;;
      width: 18px!important;;
      min-width: 18px!important;
    }
  }


.image-files {
  margin-top: 15px;
}




.popupImages {
  background-color: #fff;
  align-items: center;
  margin-top: 20px;
  @media screen and (max-width:992px) {
    width: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    background: #fff;
  }


}


.popupPdf {
  background-color: rgba(0, 0, 0, 0.8);
  align-items: center;
  margin-top: 20px;
  iframe {
    width: 100%;
    height: 100%;
    min-height: 500px;
  }
}

.popup-content {
  position: relative;
  background-color: #fff;
  padding: 20px;
}

.close-button {
  position: absolute;
  top: 0%;
  transform: translateX(-100%);
  left: 100%;
  margin: 0px !important;
  margin-top: 10px!important;
  padding: 0px;
  background: none;
  color: #2b358d;
  margin-right: 10px!important;
  svg {
    height: 26px;
    width: 26px;
    margin-right: 10px;
    path {
      fill: $primary;
    }
  }
}

.file-container {
  text-align: center;
}

.file-viewer {
  max-width: 100%;
  max-height: 100%;
  
}

</style>
